import React from "react";

import Entire from "../Entire";
import BlogTwo from "../Middle/BlogTwo";
import Bottom from "../Bottom/Bottom";
import Footer from "../Footer/Footer"
function FullPage() {
  return (
    <div>

      <Entire />
      <BlogTwo />
      <Bottom />
      <Footer />
    </div>
  );
}

export default FullPage;
